import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { SIcon, SRow } from '@avalara/skylab-sdk/react';
import { selectState } from '../../selectors';
import { BlueHeading, CheckItem, Slider } from '../shared/accordion-styled-components';
import CustomOfferDetails from './custom-offer-details';
const OfferDetails = () => {
    const { offer: { offerDetails, offerName, offerFlow, }, } = useSelector(selectState);
    const accordionOpenDefaults = offerDetails === null || offerDetails === void 0 ? void 0 : offerDetails.map(({ openAccordion }) => !!openAccordion);
    const [accordionOpenStatuses, setAccordionOpenStatuses] = useState(accordionOpenDefaults || []);
    const toggleAccordion = (i) => {
        accordionOpenStatuses[i] = !accordionOpenStatuses[i];
        setAccordionOpenStatuses([...accordionOpenStatuses]);
    };
    if (!offerDetails)
        return null;
    return (React.createElement(React.Fragment, null,
        offerDetails.map(({ accordionHeaderText, features, offerInfo, showOfferName }, i) => React.createElement("div", { key: i, className: i === 0 ? 'pad-top-md' : '' },
            React.createElement("hr", { className: 'pad-bottom-sm' }),
            React.createElement("span", { className: 'flex align-items-center pad-bottom-sm' },
                React.createElement("button", { className: 'ghost-blue icon', onClick: () => toggleAccordion(i) },
                    React.createElement(SIcon, { className: 'text-md', name: accordionOpenStatuses[i] ? 'chevron-up' : 'chevron-down', "aria-label": accordionOpenStatuses[i] ? 'Collapse offer details' : 'Expand offer details', role: 'button' })),
                React.createElement("div", { className: 'flex flex-dir-col' },
                    React.createElement(BlueHeading, { className: 'font-bold pad-left-sm' }, accordionHeaderText))),
            React.createElement(Slider, { show: accordionOpenStatuses[i] },
                React.createElement("div", { className: 'pad-left-lg' },
                    showOfferName && React.createElement("h3", null, offerName),
                    features && features.map((feature, j) => React.createElement(CheckItem, { key: `feature${j}` },
                        React.createElement(SIcon, { name: 'check' }),
                        React.createElement("span", null, feature))),
                    React.createElement(SRow, null,
                        offerInfo && offerInfo.map((info, j) => (React.createElement("p", { key: `offerInfo${j}`, className: 'text-md font-normal margin-bottom-md margin-left-lg' }, info))),
                        React.createElement(CustomOfferDetails, { offerFlow: offerFlow })))))),
        React.createElement("hr", { className: 'pad-top-lg', style: { width: '100%' } })));
};
export default OfferDetails;
